import React from 'react';
import PropTypes from 'prop-types';
import { Button as MuiButton } from '@mui/material';

// Component scope - Constants and static data
const BUTTON_VARIANTS = ['contained', 'outlined', 'text'];
const BUTTON_COLORS = ['primary', 'secondary', 'error', 'warning', 'info', 'success'];
const BUTTON_SIZES = ['small', 'medium', 'large'];

/**
 * App Button Component - Wrapper for MUI Button
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppButtonComponent
 */
const AppButtonComponent = ({ 
  variant = 'contained', 
  color = 'primary',
  size = 'medium',
  loading = false,
  disabled = false,
  children,
  ...props 
}) => {
  // Return/rendering
  return (
    <MuiButton
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? 'Loading...' : children}
    </MuiButton>
  );
};

AppButtonComponent.propTypes = {
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  color: PropTypes.oneOf(BUTTON_COLORS),
  size: PropTypes.oneOf(BUTTON_SIZES),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  fullWidth: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  sx: PropTypes.object,
};

export default AppButtonComponent;

